import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { AvailableDaysItem, LoginUserItem } from "@/types";
import CustomDatePicker from "@edusogno/composites/calendar";
import { useLocation } from "react-router-dom";
import { useMe } from "@/data/user";
import { maixpanelTrackEventProps } from "@/mixpanel/MixpanelUtils";
import MobileLayout from "@/components/one-to-one/MobileLayout";
import i18n from "@/utils/i18n";
import Warning from "@/components/ui/Warning";
import { Trans } from "react-i18next";
import Button from "@edusogno/primitives/button.js";
import { t } from "i18next";
import { cn } from "@edusogno/lib/utils";
import { useModalAction } from "@/contexts/modal/Context";

interface MobileViewProps {
  date: Dayjs;
  setDate: (date: Dayjs) => void;
  availableDays: Dayjs[];
  availableDaysArray: AvailableDaysItem[];
}

interface StateProps {
  exerciseCorrection: string;
}

const BookMockTestMobileView = ({
  date,
  setDate,
  availableDaysArray,
  availableDays,
}: MobileViewProps) => {
  const location = useLocation();
  const stateData = location?.state as StateProps;
  const { exerciseCorrection } = stateData;
  const [selectedTutor, setSelectedTutor] = useState<string>();
  const [hour, setHour] = useState<string | null>(null);
  const [steps, setSteps] = useState(1);
  // mixpanel integration
  const { me } = useMe();
  const mixpanelPropsData = JSON.stringify(
    maixpanelTrackEventProps("Exercise", me?.item?.user as LoginUserItem),
  );
  const { openModal } = useModalAction();

  const StepOne = () => {
    return (<div className={"w-full gap-x-4 flex flex-col h-full justify-between"}>
      <CustomDatePicker
        lang={i18n.language as "en" | "it" | "es" | "fr" | "de"}
        openDates={availableDays}
        onValueChange={(value) => {
          if (value) {
            setDate(dayjs(value as string));
          }
        }}
        minDate={dayjs()}
        value={date.format("YYYY-MM-DD HH:mm:ss")}
        type={"single"}
        className={"w-full"}
      />
      <div className={"flex w-full flex-col gap-2"}>
        <Warning
          text={
            <Trans
              i18nKey="one_to_one.warning_timezome"
              components={{
                b: <b className="font-semibold" />,
              }}
            ></Trans>
          }
        />
        <Button
          disabled={!date}
          onClick={() =>
            setSteps(2)
            // navigate(routes.one_to_one_select_hour)
          }
          color={"primary"}
          size={"md"}
          className={"mx-auto"}
        >
          {t("btns.next")}
        </Button>
      </div>
    </div>)
  }
  const StepTwo = () => {


    return (<div className={"w-full flex flex-col h-full justify-between gap-x-4"}>
      <div className="grid grid-cols-2 gap-2">
        {availableDaysArray?.map((cal) =>
          dayjs(cal.date).format("HH:mm"),
        ).map((time) => <Button onClick={() => {
          if (time) {
            setHour(time);
            const tutor = availableDaysArray.find(
              (el) =>
                el.date ===
                `${date.format("YYYY-MM-DD")} ${time}`,
            );
            if (tutor) {
              setSelectedTutor(tutor.tutor);
            }
          }
        }} className={cn`${hour == time ? "bg-brand-deep text-white" : "bg-[#EEE] text-secondary"}border-0`}>{time}</Button>)}
      </div>

      <div className={"flex w-full flex-col gap-2"}>
        <Warning
          text={
            <Trans
              i18nKey="one_to_one.warning_timezome"
              components={{
                b: <b className="font-semibold" />,
              }}
            ></Trans>
          }
        />
        <Button
          data-track-props={mixpanelPropsData}
          data-track-eventtype={`Excersie_Confirm_Live_Correction`}
          disabled={!hour}
          onClick={() => {
            openModal(
              "CONFIRM_MOCK_TEST_MODAL",
              {
                date,
                hour,
                exercise: exerciseCorrection,
                tutor: selectedTutor,
              },
              {
                heading: t("one_to_one.confirm_first_session_modal.title"),
              },
            )
          }}

          size={"md"}
          className={"mx-auto bg-socials-whatsapp"}
        >
          {t("btns.confirm")}
        </Button>
      </div>
    </div>)
  }

  return (

    <MobileLayout
      title={t("mock_test.header")}
      subtitle={t("mock_test.sub_header")}
      isOneToOne={false}
      className="h-full"
    >
      {steps == 1 && <StepOne />}
      {steps == 2 && <StepTwo />}
    </MobileLayout>
  );
};

export default BookMockTestMobileView;
